import React from "react";

interface KoruLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Koru Logo Component
 *
 * Renders the Koru app logo as an inline SVG with gradient fill.
 * Supports custom sizing via width/height props or CSS classes.
 */
const KoruLogo: React.FC<KoruLogoProps> = ({
  className = "",
  width,
  height,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 138 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient
        id="koruLogoGradient"
        x1="106.217"
        y1="3.0464"
        x2="22.7172"
        y2="104.546"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#38EE6F" />
        <stop offset="0.5" stopColor="#99FFB8" />
        <stop offset="1" stopColor="#20883F" />
      </linearGradient>
    </defs>
    <path
      d="M132.965 62.302C130.864 64.2155 125.965 60.8021 121.965 58.3021C139.815 96.3021 71.4654 120.802 57.6159 86.4599C47.4556 61.2658 69.2423 48.4742 84.6159 68.4599C89.067 58.4779 75.9654 49.5465 65.6159 49.5465C39.7919 49.5465 33.5869 70.0451 43.4654 89.8021C45.7154 94.3021 47.3852 98.582 54.9654 104.302C57.6159 106.302 42.9654 102.355 36.9654 99.802C13.4654 89.802 1.00466 65.5325 4.61589 45.4599C5.86166 38.5354 7.84476 33.47 10.6159 29.9599C18.1159 20.4599 12.9736 34.1084 18.9654 37.3021C18.6883 33.607 22.4166 13.8697 37.9654 6.80209C48.9654 1.80209 36.9654 14.8021 36.9654 22.3021C46.4654 -1.1979 77.9654 -2.19791 80.4654 1.80209C83.5204 6.69014 64.4654 8.80209 62.4654 16.3021C79.4654 5.30209 102.965 5.30208 105.965 10.3021C108.965 15.3021 90.4654 16.3021 87.4654 19.3021C100.965 16.3021 130.397 26.6523 128.465 31.8021C126.965 35.8021 116.965 31.8021 109.965 33.3021C116.465 34.3021 136.465 57.8021 132.965 62.302Z"
      fill="url(#koruLogoGradient)"
    />
  </svg>
);

export { KoruLogo };
export default KoruLogo;
